import { createAction } from '@reduxjs/toolkit';

export const addRoomSuccess = createAction('ADD_ROOM_MEASURE_SUCCESS');
export const addRoomMeasure = createAction('ADD_ROOM_MEASURE');
export const deleteMeasure = createAction('DELETE_MEASURE');
export const editMeasure = createAction('EDIT_MEASURE');
export const editedRow = createAction('EDITED_ROW');
export const saveEdit = createAction('SAVE_EDIT');
export const saveEditSuccess = createAction('SAVE_EDIT_SUCCESS');
export const updateRoomPrice = createAction('UPDATE_ROOM_PRICE');
export const updatePadPrice = createAction('UPDATE_PAD_PRICE');